import { useNavigate } from 'react-router-dom';

const features = [
  {
    icon: 'ri-coins-line',
    title: 'Kredi Bazlı Kullanım',
    desc: 'Esnek kredi sistemi ile talep başına ödeme yapın, abonelik zorunluluğu yok.',
  },
  {
    icon: 'ri-magic-line',
    title: 'Uyumlu Terapist Önerileri',
    desc: 'Akıllı eşleşme algoritması en uygun terapistleri öncelikli olarak sunar.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Personel İhtiyacı Oluşturma',
    desc: 'Şube, pozisyon ve uzmanlığa göre detaylı talepler oluşturun.',
  },
  {
    icon: 'ri-search-line',
    title: 'Arama ve Filtreleme',
    desc: 'Şehir, uzmanlık, deneyim ve diğer kriterlere göre arama yapın.',
  },
  {
    icon: 'ri-folder-user-line',
    title: 'Terapist Havuzu / CRM',
    desc: 'Favoriler, görüşülenler, gizli profiller ve aktif bağlantılarınızı yönetin.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Şube Bazlı Yönetim',
    desc: 'Birden fazla şubeniz varsa her biri için ayrı kredi ve CRM yönetimi.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Admin Onaylı Havuz',
    desc: 'Sadece doğrulanmış ve onaylı terapistler ile çalışın.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Destek ve Şikayet',
    desc: 'Etik dışı davranışlara karşı şikayet sistemi ve özel destek hattı.',
  },
];

export default function ForSpaSection() {
  const navigate = useNavigate();

  return (
    <section id="spa-isletmeleri-icin" className="w-full bg-off-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {/* Left: Feature Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 order-2 lg:order-1">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="group p-4 md:p-5 bg-white rounded-xl border border-gray-100 hover:border-soft-gold-300 hover:shadow-soft transition-all duration-300"
                >
                  <div className="w-9 h-9 rounded-lg bg-soft-gold-50 flex items-center justify-center mb-3 group-hover:bg-soft-gold-500 transition-colors duration-300">
                    <i className={`${f.icon} text-soft-gold-600 text-base group-hover:text-white transition-colors duration-300`} />
                  </div>
                  <h3 className="text-sm font-semibold text-deep-navy-500 mb-1">{f.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>

            {/* Right: Heading + CTA */}
            <div className="order-1 lg:order-2 lg:sticky lg:top-24">
              <span className="inline-block px-3 py-1 bg-soft-gold-100 text-soft-gold-700 text-xs font-semibold rounded-full mb-4">
                Spa İşletmeleri İçin
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
                İşletmeniz için doğru terapisti{' '}
                <span className="text-soft-gold-600">güvenli</span> ve kontrollü şekilde bulun
              </h2>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-6">
                Kredi bazlı sistem ile sadece gerçek bağlantı oluştuğunda ödeme yapın. Admin onaylı terapist havuzu, CRM araçları ve şube bazlı yönetim ile personel süreçlerinizi optimize edin.
              </p>
              <button
                onClick={() => navigate('/spa-kayit')}
                className="px-6 py-3 rounded-full text-sm font-semibold text-white bg-soft-gold-500 hover:bg-soft-gold-600 transition-colors shadow-soft cursor-pointer whitespace-nowrap"
              >
                Spa İşletmesi Olarak Başvur
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}